import type { GestureInput } from "../audio/types";
import type { Instrument, InstrumentVariant, Tuning } from "../data/instruments";

export interface InstrumentPlayerProps {
  instrument: Instrument;
  variant: InstrumentVariant;
  tuning: Tuning;
  activeNotes: string[];
  onNoteStart: (gesture: GestureInput) => void;
  onNoteEnd: (noteName: string) => void;
  onControl: (controlId: string, value?: number | string | boolean) => void;
}

export function triggerMomentary(
  props: Pick<InstrumentPlayerProps, "onNoteStart" | "onNoteEnd">,
  noteName: string,
  ornament: string,
  velocity = 0.72,
  durationMs = 360
): void {
  props.onNoteStart({ source: "button", noteName, velocity, ornament });
  window.setTimeout(() => props.onNoteEnd(noteName), durationMs);
}

export function noteForIndex(notes: string[], index: number): string {
  return notes[index % notes.length] ?? "C4";
}
